"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    viewBox: "5 5 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      fill: "currentColor",
      d: "M12.591 19.3c-.628 0-1.136.492-1.136 1.1 0 .608.508 1.1 1.136 1.1.628 0 1.136-.492 1.136-1.1 0-.608-.508-1.1-1.136-1.1zm-7.955-1.1c-.627 0-1.136.492-1.136 1.1v2.2c0 .608.509 1.1 1.136 1.1.628 0 1.137-.492 1.137-1.1v-2.2c0-.608-.509-1.1-1.137-1.1zm22.728 0c-.628 0-1.137.492-1.137 1.1v2.2c0 .608.509 1.1 1.137 1.1.627 0 1.136-.492 1.136-1.1v-2.2c0-.608-.509-1.1-1.136-1.1zm-5.682-7.7h-4.546V9.092A2.19 2.19 0 0018.273 7.2C18.273 5.985 17.255 5 16 5c-1.255 0-2.273.985-2.273 2.2a2.19 2.19 0 001.137 1.892V10.5h-4.546c-1.883 0-3.409 1.477-3.409 3.3v9.9c0 1.823 1.526 3.3 3.409 3.3h11.364c1.883 0 3.409-1.477 3.409-3.3v-9.9c0-1.823-1.526-3.3-3.409-3.3zm-3.727 2.2l-.569 2.2h-2.772l-.569-2.2h3.91zm4.863 11c0 .608-.509 1.1-1.136 1.1H10.318c-.627 0-1.136-.492-1.136-1.1v-9.9c0-.608.509-1.1 1.136-1.1h1.387l.886 3.564a1.13 1.13 0 001.136.836h4.546a1.13 1.13 0 001.136-.836l.886-3.564h1.387c.627 0 1.136.492 1.136 1.1v9.9zm-3.409-4.4c-.628 0-1.136.492-1.136 1.1 0 .608.508 1.1 1.136 1.1.628 0 1.136-.492 1.136-1.1 0-.608-.508-1.1-1.136-1.1z"
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Widget.js.map